import { Box, Center } from "@chakra-ui/layout"
import React, { useCallback } from "react"

import SnsButton from "~/components/atoms/SnsButton"
import Typography from "~/components/atoms/Typography"
import { Color, SpacingSize, TextSize } from "~/consts/style-mixins"

import { Inline } from "../components/Inline"
import { Section } from "../components/Section"

const LINE_AUTH_LINK: string = (() => {
  const backendPath = "/auth/oauth/line/register"
  return process.env.ENV === "local"
    ? `${process.env.INFRA_INTERN_URL}${backendPath}`
    : `${process.env.APP_HOST}${backendPath}`
})()

export const RegisterLine: React.VFC = () => {
  const onClickRegisterLine = useCallback(() => {
    // NOTE: location.searchでurlの?以降のqueryを渡し、LINE認証後のqueryも残すようにしている
    window.open(LINE_AUTH_LINK + location.search)
  }, [])

  return (
    <Section
      title={
        <>
          SNSを利用して登録
          <Inline fontSize={TextSize.S}>（任意）</Inline>
        </>
      }
    >
      <Box textAlign="center">
        <Typography type="SubLabel" colorProp={Color.Line}>
          ＼ 通知が届くLINEがオススメ！／
        </Typography>
      </Box>
      <Center mt={SpacingSize.XS}>
        <Box w={236}>
          <SnsButton type="button" snsType="Line" size="Medium" onClick={onClickRegisterLine}>
            LINEで登録する
          </SnsButton>
        </Box>
      </Center>

      <Center mt={SpacingSize.M}>
        <Typography type="SubNote">
          登録とログイン時の
          <Inline color={Color.Attention} fontWeight={700}>
            入力項目を短縮
          </Inline>
          できます！
        </Typography>
      </Center>
    </Section>
  )
}
